"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _CheckboxRadio = _interopRequireDefault(require("../baseComponents/CheckboxRadio"));
var _TextField = _interopRequireDefault(require("../baseComponents/TextField"));
var _Button = _interopRequireDefault(require("../baseComponents/Button"));
var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));
var _utils = require("../../utils/utils");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AssetsManager = function AssetsManager(props) {
  var _props$textFieldProps;
  var options = props.options;
  var inputValue = props.textFieldProps.value;
  var id = (0, _react.useRef)("asset-component-".concat(Math.floor(Math.random() * 100000000)));
  (0, _react.useEffect)(function () {
    document.addEventListener("keydown", onKeyDown, false);
    return function () {
      document.removeEventListener("keydown", onKeyDown, false);
    };
  }, []);
  function onKeyDown(e) {
    var key = _keyDownHandler["default"].getKeysFromEvent(e);
    if (key === _keyDownHandler["default"].keys.enter) {
      var btn = document.querySelector("#".concat(id.current, " .createAssetBtn"));
      if (btn) {
        btn.click();
      }
    }
  }
  var renderListItem = function renderListItem(option) {
    var _props$mainActionBtnP2, _props$secondaryActio2, _props$createBtnProps2;
    var mainBtn = props !== null && props !== void 0 && props.mainActionBtnProps ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      colorTheme: "teal",
      size: "xsmall",
      shapeStyle: "stroke",
      radius: "square",
      onClick: function onClick(event, button) {
        var _props$mainActionBtnP;
        props === null || props === void 0 || (_props$mainActionBtnP = props.mainActionBtnProps) === null || _props$mainActionBtnP === void 0 || _props$mainActionBtnP.onClick(event, button, option);
      },
      text: props === null || props === void 0 || (_props$mainActionBtnP2 = props.mainActionBtnProps) === null || _props$mainActionBtnP2 === void 0 ? void 0 : _props$mainActionBtnP2.label,
      animated: true,
      animateOnClick: false
    }) : "";
    var secondaryBtn = props !== null && props !== void 0 && props.secondaryActionBtnProps ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      colorTheme: "grey",
      size: "xsmall",
      shapeStyle: "stroke",
      radius: "square",
      onClick: function onClick(event, button) {
        var _props$secondaryActio;
        props === null || props === void 0 || (_props$secondaryActio = props.secondaryActionBtnProps) === null || _props$secondaryActio === void 0 || _props$secondaryActio.onClick(event, button, option);
      },
      text: props === null || props === void 0 || (_props$secondaryActio2 = props.secondaryActionBtnProps) === null || _props$secondaryActio2 === void 0 ? void 0 : _props$secondaryActio2.label,
      animated: true,
      animateOnClick: false
    }) : "";
    var isFullMatch = option.fullMatch === true;
    var isPartialMatch = option.partialMatch === true;
    var isNew = option["new"] === true;
    var noMatch = !option.fullMatch && !option.partialMatch && !option["new"];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: " listItem ".concat(isFullMatch || isPartialMatch || isNew ? "selected" : ""),
      key: option.value,
      id: id.current
    }, isFullMatch && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-checkmark"
    }), isPartialMatch && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-dash"
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "h8"
    }, " ", option["new"] ? "\"".concat(option.label, "\"") : option.label, " "), option["new"] ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      colorTheme: "teal",
      size: "xsmall",
      shapeStyle: "stroke",
      radius: "square",
      onClick: function onClick(event, button) {
        var _props$createBtnProps;
        props === null || props === void 0 || (_props$createBtnProps = props.createBtnProps) === null || _props$createBtnProps === void 0 || _props$createBtnProps.onClick(event, button, option);
      },
      text: props === null || props === void 0 || (_props$createBtnProps2 = props.createBtnProps) === null || _props$createBtnProps2 === void 0 ? void 0 : _props$createBtnProps2.label,
      animated: true,
      animateOnClick: false,
      className: "createAssetBtn"
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "buttonContainer"
    }, isFullMatch && secondaryBtn, isPartialMatch && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mainBtn, secondaryBtn), noMatch && mainBtn));
  };
  function sortArray(a, b) {
    return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
  }
  var fullMatchOptions = props.options.filter(function (opt) {
    return opt.fullMatch === true;
  });
  fullMatchOptions.sort(sortArray);
  var partialMatchOptions = props.options.filter(function (opt) {
    return opt.partialMatch === true;
  });
  partialMatchOptions.sort(sortArray);
  var noMatch = props.options.filter(function (opt) {
    return !opt.fullMatch && !opt.partialMatch && !opt["new"];
  });
  noMatch.sort(sortArray);
  var newOpt = props.options.filter(function (opt) {
    return opt["new"] === true;
  });
  newOpt.sort(sortArray);
  var containerClasses = (0, _classnames["default"])("asset-component");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-container"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    className: "the-svg-icons",
    name: "glyph-tag",
    type: "glyph"
  })), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    fieldStyle: "text-field-outline",
    placeholder: props.textFieldProps.placeholder,
    value: props.textFieldProps.value,
    onChange: function onChange(e) {
      return props.textFieldProps.onChange(e);
    },
    timeoutOptions: (_props$textFieldProps = props.textFieldProps) === null || _props$textFieldProps === void 0 ? void 0 : _props$textFieldProps.timeoutOptions
  }), inputValue && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-remove",
    onClick: function onClick(e) {
      e.stopPropagation();
      props.clearSelection();
    }
  }))), (options.length > 0 || props.textFieldProps.value !== "") && /*#__PURE__*/_react["default"].createElement("div", {
    className: "optionsListingContainer"
  }, options.length == 1 && options[0]["new"] || options.length === 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.noAssetHeader && /*#__PURE__*/_react["default"].createElement("p", {
    className: "h8"
  }, props.noAssetHeader)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.chooseAssetHeader && /*#__PURE__*/_react["default"].createElement("p", {
    className: "h8"
  }, props.chooseAssetHeader)), newOpt.map(function (option) {
    return renderListItem(option);
  }), fullMatchOptions.map(function (option) {
    return renderListItem(option);
  }), partialMatchOptions.map(function (option) {
    return renderListItem(option);
  }), noMatch.map(function (option) {
    return renderListItem(option);
  }))), props.manageBtnProps.show ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    colorTheme: "teal",
    shapeStyle: "stroke",
    radius: "square",
    onClick: props.manageBtnProps.onClick
  }, props.manageBtnProps.label) : null);
};
AssetsManager.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    "new": _propTypes["default"].bool,
    fullMatch: _propTypes["default"].bool,
    partialMatch: _propTypes["default"].bool
  })),
  createBtnProps: _propTypes["default"].shape({
    onClick: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired
  }).isRequired,
  mainActionBtnProps: _propTypes["default"].shape({
    onClick: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired
  }).isRequired,
  secondaryActionBtnProps: _propTypes["default"].shape({
    onClick: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired
  }).isRequired,
  textFieldProps: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
    placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
    timeoutOptions: _propTypes["default"].oneOfType([_propTypes["default"].shape({
      time: _propTypes["default"].number,
      callback: _propTypes["default"].func
    }), _propTypes["default"].bool])
  }).isRequired,
  noAssetHeader: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  chooseAssetHeader: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  clearSelection: _propTypes["default"].func.isRequired,
  manageBtnProps: _propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  })
};
AssetsManager.defaultProps = {
  options: [],
  manageBtnProps: {
    show: false,
    onClick: function onClick() {},
    label: ""
  }
};
var _default = exports["default"] = AssetsManager;